import React, {useEffect, useMemo, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import AddNewGatewayConfig from './modal/AddNewGatewayConfig'
import EditGatewayConfig from './modal/EditGatewayConfig'
import {
  useGetGatewayConfigsQuery,
  useDeleteGatewayConfigMutation,
} from '../../../../services/cellcast'
import {toast} from 'react-toastify'
import ReactPaginate from 'react-paginate'
import {useLoadedData} from '../../../hooks/useGetLoadedData'

const GatewayConfigsList = () => {
  ////////////////////////////////////////ALL USESTATE//////////////////////////////////
  const [showGatewayConfig, setShowGatewayConfig] = useState(false)
  const [editGatewayConfig, setEditGatewayConfig] = useState(false)
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [editGatewayConfigData, setEditGatewayConfigData] = useState<any>({})
  const [deleteIds, setDeleteIds] = useState<any>()
  const {calculate, loadedData, setLoadedData} = useLoadedData()

  const [page, setPage] = useState<any>({
    page: 1,
    size: 10,
    searchKey: '',
  })

  /////////////////////////////////////USE-EFFECT//////////////////////////////////////
  const {
    data: gatewayConfigsData,
    refetch,
    isFetching,
    isLoading: isLoadingGatewayConfigs,
  } = useGetGatewayConfigsQuery(page)

  const [deleteGatewayConfig] = useDeleteGatewayConfigMutation()

  useEffect(() => {
    refetch()
  }, [page.page, page.size, refetch])

  useEffect(() => {
    if (gatewayConfigsData?.data && gatewayConfigsData?.data?.total) {
      const calculatedData = calculate(page.page, page.size, gatewayConfigsData?.data?.total)
      setLoadedData(calculatedData)
    }
  }, [gatewayConfigsData, page.page, page.size])

  useEffect(() => {
    if (confirm == true) {
      deleteGatewayConfig({id: deleteIds})
        .unwrap()
        .then((res) => {
          toast.success(res.message)
        })
        .catch()
        .finally(() => {
          setDeleteIds('')
          setConfirm(false)
          refetch()
        })
    }
  }, [confirm, deleteGatewayConfig, refetch, deleteIds])

  /////////////////////////////////use-MEMO//////////////////////////////////////

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete this gateway config?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  const GCModal = useMemo(
    () => (
      <AddNewGatewayConfig
        show={showGatewayConfig}
        handleClose={() => setShowGatewayConfig(false)}
        refetch={refetch}
      />
    ),
    [showGatewayConfig, refetch]
  )

  const editGCModal = useMemo(
    () => (
      <EditGatewayConfig
        data={editGatewayConfigData}
        setData={setEditGatewayConfigData}
        show={editGatewayConfig}
        handleClose={() => setEditGatewayConfig(false)}
        refetch={refetch}
      />
    ),
    [editGatewayConfig, editGatewayConfigData, refetch]
  )
  ///////////////////////////////////ALL Function //////////////////////////////

  const handlePageChange = (newPage: number) => {
    setPage({...page, page: newPage})
  }

  const handleLimitChange = (newSize: number) => {
    setPage({...page, size: newSize, page: 1})
  }

  return (
    <>
      {GCModal}
      {editGCModal}
      {confirmation}
      <div className='card mb-0'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <div className='d-flex align-items-center position-relative my-1'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search gateway configs'
                value={page?.searchKey}
                onChange={(e) => setPage({...page, searchKey: e.target.value})}
              />
            </div>
          </div>
          <div className='card-toolbar m-0'>
            <div className='d-flex gap-3 align-items-center'>
              <button className='btn btn-primary' onClick={() => setShowGatewayConfig(true)}>
                Create
              </button>
            </div>
          </div>
        </div>

        {isLoadingGatewayConfigs || isFetching ? (
          <div className='row flex-center h-300 mb-10'>
            <Spinner />
          </div>
        ) : gatewayConfigsData && gatewayConfigsData?.data?.items?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Gateway Name</th>
                      <th>Provider</th>
                      <th>URL</th>
                      <th>Supported Features</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {gatewayConfigsData?.data?.items?.map((val: any, id: number) => (
                      <tr key={id}>
                        <td>{val?.name}</td>
                        <td>{val?.provider}</td>
                        <td className='text-break' style={{maxWidth: '200px'}}>
                          {val?.url}
                        </td>
                        <td>
                          {val?.supporatedFeatures?.map((feature: string, index: number) => (
                            <span key={index} className='badge badge-light-info me-1'>
                              {feature}
                            </span>
                          ))}
                        </td>
                        <td>
                          <span
                            className={`badge badge-${
                              val?.isDeleted ? 'light-danger' : 'light-success'
                            }`}
                          >
                            {val?.isDeleted ? 'Inactive' : 'Active'}
                          </span>
                        </td>
                        <td className='text-end'>
                          <span
                            onClick={() => {
                              setEditGatewayConfig(true)
                              setEditGatewayConfigData({...val})
                            }}
                            className='btn btn-bg-light btn-active-color-primary btn-sm me-2'
                          >
                            Edit
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className='abcd'>
              <select
                onChange={(e) => {
                  setPage({...page, size: e.target.value})
                }}
                value={page.size}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              Show {loadedData.startLoad} - {loadedData.endLoad} of{' '}
              {gatewayConfigsData?.data?.total}
              <ReactPaginate
                previousLabel='<'
                nextLabel='>'
                pageCount={gatewayConfigsData?.data?.totalPages}
                onPageChange={(e) => {
                  handlePageChange(e.selected + 1)
                }}
                containerClassName={'pagination'}
                previousLinkClassName={'pagination__link'}
                nextLinkClassName={'pagination__link'}
                disabledClassName={'pagination__link--disabled'}
                activeClassName={'pagination__link--active'}
              />
            </div>
          </div>
        ) : (
          <div className='row flex-center h-300 mb-10'>
            <div className='text-center'>
              <h3>No Gateway Configs Found</h3>
              <p>Click "Create New Gateway Config" to add a new gateway configuration</p>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default GatewayConfigsList
